import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "ya-emptypage",
  templateUrl: "./emptypage.component.html",
  styleUrls: ["./emptypage.component.scss"]
})
export class EmptypageComponent implements OnInit {
  @Input() emptyTitle: string = "phEmptyPage_Title";
  @Input() emptyContent: string = "phEmptyPage_Message";

  constructor() { }

  ngOnInit() {
  }

}
